<template>
<body>

  <!-- JACKPOT START -->
  <div class="jpBox" v-on="countDownTimer()">
    <div class="jpBoxFon">
      <div class="stars"></div>
      <div class="jpContent">
        <div class="jpLogo">
          <img src="@/assets/images/banner-1.svg" alt="" />
        </div>
        <div class="jpHeader">
          <img src="@/assets/images/jpHeader.svg" alt="" />
        </div>
        <div class="jpNumber" v-if="$store.state.jackpotlast">
          <!--<span v-if="$store.state.jackpotlast">{{$store.state.jackpotlast.Amount.toFixed(2)}}</span>-->
					<span>{{$store.state.jackpotlast.Amount.toFixed(2)}}</span>
					<div class="barcode">
						<p>{{getcode($store.state.jackpotlast.TicketID)}}</p>
					</div>
        </div>
      </div>
    </div>
  </div>
  <!-- JACKPOT STOP -->
  
</body>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'Jackpot',
  timer: 0,
  created: function () {
    this.$store.dispatch('apirequest', {token: 0, name: "jackpot/last/" + this.$route.params.Token});
  },
  computed: {
    
    game: function(){
      let game = { count: 3};
      return game;
    }
  },
  destroyed() {
      clearInterval(this.$options.timer);
    },
  methods: {
    countDownTimer() {
      let count= 0;
      if(!this.$options.timer){
        this.$options.timer = setInterval(() => {
          if(this.game.count <= 0){
            window.location.assign("/championship/cashier/TV/" + this.$route.params.Token);
          }
            this.game.count -= 1
        }, 1000)
      }
    }, 
    getcode(id){
      let code = "" + id.toString();
      if(id == 13) {
        code = id;
      }else{
        let num = 12 - id.toString().length;
        let odd, even;
        for(let i = 0; i < num; i++){
          if(i == (num -1)){
            code = '1' + code;
          }else{
            code = '0' + code;
          }     
        }
        for(let i = code.length - 1; i >= 0; i--){
                if(i % 2 == 0){
                  even += code[i];
                }else{
                  odd += code[i];
                }
              }
              let control = odd * 3 + even;
              let lastone = control.toString().split('').pop();
              if(lastone == 0){
                code = code + '0';
              }else{
                code = code + (10 - lastone);
              }
      }
      return code
    },
  }
};
</script>

